import { HTTP } from '@/API/base/client'

export const logMetric = (name, tags) => {
  return HTTP.post('/careers/metrics', {
    name,
    tags,
  })
}
